import React from "react";
import { Link } from "react-router-dom";
import dummyRoundedImage from "../assets/images/dummy-rounded-image.png"
import { useAppContext } from "../context/AppContext";
import parsePhoneNumber from 'libphonenumber-js'

/**
 * Topbar.
 *
 * Trimmed from 220 lines to ~90. Removed: the #light-dark-mode toggle (no
 * handler was ever wired to it and nothing in the app sets data-bs-theme), a
 * ~110-line commented-out notification dropdown carried over from the template,
 * the commented-out template profile menu, an empty useEffect, an unused
 * toggleSidebar stub, and five commented-out imports.
 */
function Header({ expandSidebar }) {
    const { twilioPhone } = useAppContext();

    return (
        <div className="topbar-custom">
            <div className="container-fluid">
                <div className="d-flex justify-content-between">
                    <ul className="list-unstyled topnav-menu mb-0 d-flex align-items-center">
                        <li>
                            <button className="button-toggle-menu nav-link" onClick={expandSidebar}>
                                <i className="ri-menu-line fs-18 fw-bold"></i>
                            </button>
                        </li>
                    </ul>

                    <ul className="list-unstyled topnav-menu mb-0 d-flex align-items-center">
                        <li className="d-none d-sm-flex">
                            <button type="button" className="btn nav-link" data-toggle="fullscreen">
                                <i data-feather="maximize" className="align-middle fullscreen noti-icon"></i>
                            </button>
                        </li>

                        {twilioPhone ? (
                            <li className="me-2">
                                <span className="topbar-meta">
                                    <i className="ri-phone-line"></i>
                                    {parsePhoneNumber(twilioPhone).formatInternational()}
                                </span>
                            </li>
                        ) : null}
                        <li>
                            <Link to={"/make-call"} className="linear-gradient-btn me-3">
                                <i className="ri-phone-line"></i> Make a Call
                            </Link>
                        </li>

                        <li className="dropdown notification-list topbar-dropdown">
                            <a className="nav-link dropdown-toggle nav-user me-0" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <img src={dummyRoundedImage} alt="user-image" className="rounded-circle" />
                                <span className="pro-user-name ms-2">{localStorage.getItem("userName")} <i className="mdi mdi-chevron-down"></i></span>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end profile-dropdown">
                                <Link to="/logout" className="dropdown-item notify-item">
                                    <i className="mdi mdi-location-exit fs-16 align-middle"></i>
                                    <span>Logout</span>
                                </Link>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Header;
